import axios from "axios";

// Helper function to get the Authorization headers
function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`, // Assumes token is stored in localStorage
    },
  };
}

// Service to fetch the invoice pending count report
export const getInvoicePendingCountReport = async (groupBy) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/invoice-report/invoice_pending_count_report/?group_by=${groupBy}`,
      getHeaders()
    );
    return response.data; // Return the response data
  } catch (error) {
    throw new Error(error.response?.data?.error || "Failed to fetch invoice pending count report");
  }
};
